import React from 'react';
import googleCalendar from '../../../../../assets/icons/google_calendar.svg';
import googleMeet from '../../../../../assets/icons/google-meet.svg';
import zoom from '../../../../../assets/icons/zoom.svg';
import msOutlook from '../../../../../assets/icons/ms-outlook.svg';
import stripe from '../../../../../assets/icons/stripe.svg';
import paypal from '../../../../../assets/icons/pay-pal.svg';
import zapier from '../../../../../assets/icons/zapier.svg';
import msOffice from '../../../../../assets/icons/ms-office-360.svg';

const integrations = [
  { icon: googleCalendar, name: 'Google Calendar', category: 'Calendar' },
  { icon: googleMeet, name: 'Google Meet', category: 'Video' },
  { icon: zoom, name: 'Zoom', category: 'Video' },
  { icon: msOutlook, name: 'Outlook', category: 'Calendar' },
  { icon: msOffice, name: 'Office 365', category: 'Calendar' },
  { icon: stripe, name: 'Stripe', category: 'Payments' },
  { icon: paypal, name: 'PayPal', category: 'Payments' },
  { icon: zapier, name: 'Zapier', category: 'Automation', comingSoon: true },
];

export const IntegrationsView = () => {
  return (
    <section id="integrations" className="integrations-section">
      <div className="integrations-section__inner">
        <div className="integrations-section__header">
          <span className="integrations-section__label">Works With Your Stack</span>
          <h2 className="integrations-section__title">Powerful Integrations</h2>
          <p className="integrations-section__subtitle">
            MeetOcto connects seamlessly with the tools you already use—calendars, video, payments, and more.
          </p>
        </div>

        <div className="integrations-grid">
          {integrations.map((item, index) => (
            <div
              className={`integration-card${item.comingSoon ? ' integration-card--coming-soon' : ''}`}
              key={index}
            >
              <div className="integration-card__icon">
                <img src={item.icon} alt={item.name} />
              </div>
              <span className="integration-card__name">{item.name}</span>
              <span className="integration-card__category">
                {item.comingSoon ? 'Coming Soon' : item.category}
              </span>
            </div>
          ))}
        </div>

        <p className="integrations-section__more">
          And many more integrations to come.
        </p>
      </div>
    </section>
  );
};
